import { render } from "./MarkdownRender.vue?vue&type=template&id=73bebc12&scoped=true"
import script from "./MarkdownRender.vue?vue&type=script&lang=js"
export * from "./MarkdownRender.vue?vue&type=script&lang=js"

import "./MarkdownRender.vue?vue&type=style&index=0&id=73bebc12&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73bebc12"]])

export default __exports__